import React from 'react';
import s from './Flash.scss';
export var FlashFullView = function (_a) {
    var _b = _a.deviation, files = _b.files, title = _b.title, width = _a.width, height = _a.height;
    if (!files) {
        return null;
    }
    var flashFile = files.find(function (file) { return file.type === 'flash'; });
    if (!flashFile) {
        return null;
    }
    return (React.createElement("div", { className: s['root'], style: { width: width, height: height } },
        React.createElement("iframe", { title: title, className: s['frame'], src: flashFile.src, style: {
                width: flashFile.width,
                height: flashFile.height,
                maxWidth: width,
                maxHeight: height,
            } })));
};
FlashFullView.displayName = 'FlashFullView';
export default FlashFullView;
//# sourceMappingURL=Flash.js.map